function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.364 0a8 8 0 10.001 16.002A8 8 0 008.364 0zm3.652 6.238c.004.078.006.157.006.237 0 2.426-1.847 5.224-5.225 5.224a5.197 5.197 0 01-2.814-.825 3.685 3.685 0 002.719-.76 1.838 1.838 0 01-1.716-1.276 1.827 1.827 0 00.83-.031 1.837 1.837 0 01-1.474-1.8v-.023c.248.137.53.22.832.23a1.834 1.834 0 01-.569-2.452A5.213 5.213 0 008.39 6.68a1.837 1.837 0 013.129-1.675 3.684 3.684 0 001.166-.445 1.843 1.843 0 01-.807 1.016 3.663 3.663 0 001.054-.29 3.733 3.733 0 01-.916.952z",
  fill: "currentColor"
});

var SvgLbTwitterLogo = function SvgLbTwitterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default SvgLbTwitterLogo;